<template>
  <div id="app"
       class="app"
  >

    <fullscreen-image/>

    <the-header/>

    <main>

      <the-map/>

      <div class="content">
        <router-view/>
      </div>

      <route-details v-if="rules.isFeatureItinerariesEnabled"/>

      <routes-list v-if="rules.isFeatureItinerariesEnabled"/>

      <the-timeline/>

      <mobile-navigator/>

      <copyrights-block></copyrights-block>

    </main>

  </div>
</template>

<script>
import FullscreenImage from "@/components/common/FullscreenImage/FullscreenImage";
import TheHeader from "@/components/common/TheHeader/TheHeader";
import TheMap from "@/components/common/TheMap/TheMap";
import RouteDetails from "@/components/common/RouteDetails/RouteDetails.vue";
import RoutesList from "@/components/common/RoutesList/RoutesList.vue";
import TheTimeline from "@/components/common/TheTimeline/TheTimeline";
import MobileNavigator from "@/components/common/MobileNavigator/MobileNavigator";
import CopyrightsBlock from "@/components/common/Copyrights/CopyrightsBlock.vue";
import rules from "@/config/rules";

export default {
  name: 'App',
  components: {
    CopyrightsBlock,
    FullscreenImage,
    TheHeader,
    TheMap,
    RouteDetails,
    RoutesList,
    TheTimeline,
    MobileNavigator
  },
  data() {
    return {
      rules
    }
  },
  created() {
    this.$store.dispatch('loadMainApiData')
  }
}
</script>

<style lang="scss">
.app {
  width: 100%;
  height: 100%;

  main {
    position: relative;
    height: calc(100% - var(--header-height));

    .content {
      position: absolute;
      top: $content-padding-top;
      bottom: $content-padding-bottom;
      left: 0;
      z-index: 25;
      pointer-events: none;

      *:not(.overlay-page) {
        pointer-events: all;
      }
    }
  }

  .copyrights-block {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 110;
  }

  .mapboxgl-ctrl-bottom-left {

    .mapboxgl-ctrl {
      margin: 0 0 4px 4px;
    }
  }

  .mapboxgl-ctrl-bottom-right {

    .mapboxgl-ctrl-attrib-inner {
      line-height: 1rem;
    }

    .mapboxgl-ctrl-attrib.mapboxgl-compact {
      margin: 4px;
    }
  }
}

@include smallerThan("md") {
  .app {
    main {
      .content {
        top: 0;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>
